//Directory.js
import React, { useEffect, useState } from "react";
import CourtOwnerSidebar from "../../components/courtowner/CourtOwnerSidebar";
import { FaPhone } from "react-icons/fa";

const API_BASE = "https://api.getfitindia.in/api";

function Directory() {
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const token = localStorage.getItem("courtOwnerToken");
      const res = await fetch(`${API_BASE}/courtowner/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Failed to fetch contacts");
      const data = await res.json();
      setContacts(data);
    } catch (err) {
      console.error("Error loading contacts:", err);
    }
  };

  const getName = (u) =>
    u.name || u.fullName || u.username || u.displayName || "";

  const getMobile = (u) =>
    u.mobile ||
    u.mobileNumber ||
    u.phone ||
    u.phoneNo ||
    u.contactNumber ||
    "";

  const getInitials = (name) => {
    if (!name) return "?";
    const p = name.trim().split(" ");
    if (p.length === 1) return p[0].charAt(0).toUpperCase();
    return (p[0].charAt(0) + p[1].charAt(0)).toUpperCase();
  };

  const filteredContacts = contacts.filter((u) => {
    const name = getName(u).toLowerCase();
    const phone = getMobile(u);
    const q = search.toLowerCase();
    return name.includes(q) || phone.includes(search);
  });

  return (
    <div className="min-h-screen bg-gray-100">
      
      {/* FIXED SIDEBAR (DESKTOP) */}
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 bg-white shadow z-30">
        <CourtOwnerSidebar />
      </aside>

      {/* MAIN AREA */}
      <main className="lg:pl-64">

        {/* HEADER */}
        <div className="bg-[#0f2250] text-white sticky top-0 py-[0.4rem] z-20">
          <div className="max-w-6xl mx-auto px-4 py-4 flex items-center gap-4">

            {/* MOBILE SIDEBAR */}
            <div className="lg:hidden">
              <CourtOwnerSidebar />
            </div>

            <h1 className="text-lg font-semibold  sm:ms-0 md:ms-16 lg:ms-0">
              Directory
            </h1>
          </div>
        </div>

        {/* PAGE CONTENT */}
        <div className="max-w-6xl mx-auto px-4 py-6">

          {/* Small heading */}
          <h3 className="font-medium text-base mb-3 text-gray-700">
            All Contacts{" "}
            <span className="text-gray-500 text-sm">
              ({contacts.length} contacts)
            </span>
          </h3>

          {/* Search */}
          <div className="bg-white rounded-xl p-3 shadow flex items-center mb-6">
            <input
              type="text"
              placeholder="Search by name or mobile"
              className="w-full outline-none text-sm"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* CONTACT LIST */}
          <div className="space-y-4">
            {filteredContacts.map((u, idx) => {
              const name = getName(u);
              const phone = getMobile(u);

              return (
                <div
                  key={idx}
                  className="flex items-center justify-between p-0 sm:p-3 transition sm:bg-white sm:rounded-xl sm:shadow-sm sm:hover:shadow-md"
                >
                  {/* Left */}
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-lg bg-gray-200 flex items-center justify-center text-lg font-semibold text-gray-700">
                      {getInitials(name)}
                    </div>

                    <div>
                      <p className="font-medium text-base text-gray-800">
                        {name || "Unknown"}
                      </p>
                      <p className="text-gray-600 text-sm">
                        {phone || "No mobile number"}
                      </p>
                    </div>
                  </div>

                  {/* Right */}
                  {phone && (
                    <div className="flex items-center gap-4 text-xl">
                      <a
                        href={`tel:${phone}`}
                        className="hover:scale-105 transition"
                      >
                        <FaPhone
                          className="text-blue-600"
                          style={{ transform: "scaleX(-1.4)" }}
                        />
                      </a>
                    </div>
                  )}
                </div>
              );
            })}

            {filteredContacts.length === 0 && (
              <p className="text-gray-500 mt-4 text-sm">
                No contacts found.
              </p>
            )}
          </div>

        </div>
      </main>
    </div>
  );
}

export default Directory;
